const generateData = (rows, query) => {
  const newData = rows.map((row, key) => ({
    num: query?.page * query?.pageSize + key + 1,
    type: row.cols[0], // نوع
    id: row.cols[1], // شناسه
    name: row.cols[2], // نام
    accountNumber: row.cols[3], // شماره حساب
    fullName: row.cols[4], // نام و نام خانودگی
    balance: row.cols[6], // مانده 
    status: row.cols[7], // وضعیت
    ssoid: row.cols[8], // نام کاربری - ssoid
    remainCredit: row.cols[9],
    remainUsable: row.cols[10],
    isLoading: false,
  }));

  return newData;
};

export default generateData;
